module.exports = __webpack_public_path__ + "static/media/img_step_mobile.29041649.png";